import React from "react";
import { Outlet, Navigate } from "react-router-dom";
const ProtectedRoutesUser = ({status}) => {
    
    if (status.status && (status.Role === "user" || status.Role === "admin"))
        return <Outlet />
    else
        return <Navigate to="/Login" replace/>
}
export default ProtectedRoutesUser